<template>
  <div class="app">
    <Tracking/>
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <router-link class="navbar-brand" to="/home">
        <img
          class="navbar-brand-full"
          v-bind:src="this.logo500x100"
          v-if="this.logo500x100"
          width="auto"
          height="35"
          v-bind:alt="whitelabelName + ' Logo'"
        />
      </router-link>

      <SidebarToggler class="d-md-down-none" display="lg" />
      <p v-if="nodeEnv === 'development'">Versão de desenvolvedor {{name}}</p>
      <b-navbar-nav class="ml-auto">
        <a
          v-if="me && me.subscription && (me.subscription.status == 0 || (me.subscription.status == 2 && me.subscription.credits > 0) ) && !isMobileScreen"
          class="nav-link active"
          href="#"
          @click="goToPayments()"
        >
          <span class="badge badge-danger">CONTA FREE</span>
        </a>
        <a
          v-else-if="me && me.subscription && me.subscription.status == 1 && !isMobileScreen"
          class="nav-link active"
        >
          <span class="badge badge-info text-white" href="#" @click="goToAccount()">CONTA {{(me && me.subscription && me.subscription.planType == 'VIP') ? 'VIP' : 'PREMIUM'}}</span>
        </a>
        <a
          v-else-if="me && me.subscription && me.subscription.status == 3 && me.subscription.credits && !isMobileScreen"
          class="nav-link active"
        >
          <span class="badge badge-info text-white" href="#" @click="goToAccount()">CONTA {{(me && me.subscription && me.subscription.planType == 'VIP') ? 'VIP' : 'PREMIUM'}}</span>
        </a>
        <a
          v-else-if="me && me.subscription && (me.subscription.status == 2 || (me.subscription.status == 3  && me.subscription.credits <= 0)) && !isMobileScreen"
          class="nav-link active"
        >
          <span class="badge badge-danger">CONTA FREE</span>
        </a>
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <br/>
          <div v-if="showSubscriptionBar()">
            <div v-if="me && me.subscription && !me.subscription.isExpired && me.subscription.planType == 'FREEPASS'">
              <b-alert show variant="primary" id="box" class="text-center">
                Você é cliente <b>FREEPASS</b> e tem acesso ilimitado ao Sleeker. Você precisará renovar sua assinatura em <b>{{me.subscription.due | moment("DD/MM/YYYY")}}</b>.
              </b-alert>
            </div>
            <div v-else-if="me && me.subscription && me.subscription.status != 1 && !me.subscription.isExpired">
              <b-alert show variant="warning" id="box" v-if="!me.challengeAccess" class="text-center">
                Sua conta expira em <b>{{me.subscription.due | moment("DD/MM/YYYY")}}</b>. Até lá você ainda pode baixar <b>{{me.subscription.credits}}</b> posts.
              </b-alert>
              <b-alert show variant="warning" id="box" v-else class="text-center">
                Sua conta expira em <b>{{me.subscription.due | moment("DD/MM/YYYY")}}</b>. Até lá você ainda pode baixar <b>{{me.subscription.credits}}</b> posts. Grupo de desafio disponível até <b>{{me.challengeAccess | moment("DD/MM/YYYY")}}</b>
              </b-alert>
            </div>
            <div v-else-if="me && me.subscription.isExpired && !me.challengeAccess">
              <b-alert show variant="danger" v-if="me && me.subscription && me.subscription.status == 2 && me.subscription.isExpired" class="text-center">
                Seu teste gratuito acabou!
              </b-alert>
              <b-alert show variant="danger" v-else-if="me && me.subscription.isExpired" class="text-center">
                Renove seu plano para continuar usando o Sleeker
              </b-alert>
            </div>
            <b-alert show variant="warning" id="box" v-else-if="me && me.subscription && me.challengeAccess" class="text-center">
              Você não tem um plano ativo com o Sleeker mas tem acesso ao grupo de desafio até <b>{{me.challengeAccess | moment("DD/MM/YYYY")}}</b>.
            </b-alert>
          </div>
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="/">{{whitelabelName}}</a>
        <span class="ml-1">&copy; 2022 {{companyName}}</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import config from "../config";
//import { registerForNotification } from '../push-notification';
//import { pedirPermissaoParaReceberNotificacoes } from '../push-notification';
//import firebase from 'firebase';

import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import service from "./../service";
import { constants } from "fs";
import { isMobile } from "mobile-device-detect";
import WebFontLoader from "webfontloader";
import Tracking from "../views/Tracking";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    Tracking
  },
  data() {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      isAdmin: false,
      whitelabelLoaded: false,
      logo500x100: undefined,
      whitelabelName: "",
      companyName: "",
      whitelabel: undefined,
      isActivePremium: false
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    nodeEnv() {
      return process.env.NODE_ENV;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    nav() {
      let baseNav = { items: [] };
      baseNav.items.push({title: true, name: ""});
      if (this.whitelabel) {
        baseNav.items.push({
          name: "Início",
          url: "/home",
          icon: "fa fa-home"
        });

        baseNav.items.push({
          name: "Posts",
          url: "/design/search/1",
          icon: "icon-magnifier"
        });

        baseNav.items.push({
          name: "Stories e Reels",
          url: "/story/search/1",
          icon: "fa fa-mobile"
        });

        baseNav.items.push({
          name: "Meus " + this.whitelabel.templateName + "s",
          url: "/design/mine",
          icon: "icon-pencil"
        });

        baseNav.items.push({
          name: "Favoritos",
          url: "/design/favorites",
          icon: "fa fa-heart"
        });

        baseNav.items.push({
          name: "Grupos de Desafio",
          url: "/challenge",
          icon: "fa fa-users"
        });

        baseNav.items.push({
          name: "Site",
          url: "/site/home",
          icon: "fa fa-laptop",
          children: [{
              name: "Meu Site",
              url: "/site/home",
              icon: "fa fa-address-card-o"
            }, {
              name: "Meus Leads",
              url: "/site/leads",
              icon: "fa fa-user"
            }
          ]
        });

        baseNav.items.push({
          name: "FREEPASS",
          url: "/freepass",
          icon: "fa fa-star"
        });

        baseNav.items.push({
          name: "Sugerir " + this.whitelabel.templateName,
          url: "/request-sleeker",
          icon: "fa fa-pencil"
        });

        if (!this.whitelabel.hidePayment) {
          baseNav.items.push({
            name: "Assinar",
            url: "/payments",
            icon: "fa fa-money"
          });
        }

        /*baseNav.items.push({
            name: "eBook",
            url: "/ebook",
            icon: "fa fa-book"
          });*/

        baseNav.items.push({
          name: "E-books e Documentos",
          url: "/docs/home",
          icon: "fa fa-book",
          children: [{
              name: "Criar Ebook",
              url: "/ebook",
              icon: "fa fa-plus"
            }, {
              name: "Meus eBooks",
              url: "/ebook/mine",
              icon: "fa fa-list"
            }, {
              name: "Criar Documentos",
              url: "/docs/home",
              icon: "fa fa-plus"
            }, {
              name: "Meus Documentos",
              url: "/docs/mine",
              icon: "fa fa-list"
            }
          ]
        });

        baseNav.items.push({
            name: "Sleeker Club",
            url: "/club",
            icon: "fa fa-trophy"
          });

        baseNav.items.push({
          name: "Calendário",
          url: "/calendar",
          icon: "fa fa-calendar"
        });

        baseNav.items.push({
          name: "Tutoriais",
          url: "/tutorial",
          icon: "fa fa-tv"
        });

        baseNav.items.push({
          name: "FAQ",
          url: "/faq",
          icon: "fa fa-question"
        });

        baseNav.items.push({
          name: "Suporte",
          url: "/support",
          icon: "fa fa-phone"
        });
      }

      if (this.me &&  this.me.admin) {
        baseNav.items[0].name = "Administrador";
        this.isAdmin = true;
        baseNav.items.push(
          {
            name: "Criar Sleeker",
            icon: "plus-circle",
            class: "teste",
            url: "/editor/new",
            disabled: true,
            variant: "primary"
          },
          {
            name: "Importar PSD",
            icon: "plus-circle",
            class: "teste",
            url: "/design/upload-psd",
            disabled: true,
            variant: "primary"
          },
          {
            name: "Gerenciar Fontes",
            icon: "plus-circle",
            class: "teste",
            url: "/admin/fonts",
            disabled: true,
            variant: "success"
          },
          {
            name: "Gerenciar Templates",
            icon: "plus-circle",
            class: "teste",
            url: "/design/manage",
            disabled: true,
            variant: "warning"
          },
          {
            name: "Gerenciar Revendas",
            icon: "plus-circle",
            class: "teste",
            url: "/reseller-manage",
            disabled: true,
            variant: "warning"
          }
        );
      } else if (this.me &&  this.me.whitelabelAdmin) {
        baseNav.items[0].name = "Gerente";
      }

      return baseNav.items;
    },
    isInstagramBrowser: function() {
      var str = navigator.userAgent;
      var i = str.indexOf("Instagram");
      if (i <= -1) {
        return str;
      }
      return str;
    }
  },
  created: async function() {
    var tokenSaved = window.localStorage.getItem("sleekertoken");

    // Add an event listener
    document.addEventListener("update-me", (e) => {
      this.getMe();
    });

    if (tokenSaved != undefined) {
      this.saveToken(tokenSaved);
    }

    service.getFonts().then(result => {
      this.fontList = result.fonts;

      WebFontLoader.load({
        google: {
          families: result.fonts
        }
      });
    });

    if (!this.whitelabelLoaded) {
      this.whitelabelLoaded = true;
      service.getWhitelabel().then(response => {
        if (response && response.whitelabel) {
          this.logo500x100 = response.whitelabel.logo500x100;
          this.whitelabelName = response.whitelabel.name;
          this.companyName = response.whitelabel.companyName;
          this.whitelabel = response.whitelabel;
        }
      });
    }

    this.getMe();

    this.$on("UPDATE_ME", function() {
      this.me = undefined;
      this.getMe();
    });
  },
  methods: {
    showSubscriptionBar: function () {
      let show = true;

      if (this.$route.path.indexOf("ebook") > 0 ) {
        show = false;
      }

      if (window.location.href.indexOf("challenge") > 0 ) {
        show = false;
      }

      return show;
    },
    testeNotificacao: function () {
      service.getNotificacao().then(() => {
        
      });
    },
    saveToken: function(token) {
      service.saveToken(token).then(
        response => {
          
        },
        () => {
          //this.showError = true;
        }
      );
    },
    goToPayments: function() {
      this.$router.push("/payments/");
    },
    goToAccount: function() {
      this.$router.push("/account/");
    },
    animateBar: function () {
      let lerp = function(a,b,u) {
          return (1-u) * a + u * b;
      };
      
      let fade = function(element, property, start, end, duration) {
        var interval = 10;
        var steps = duration/interval;
        var step_u = 1.0/steps;
        var u = 0.0;
        var theInterval = setInterval(function(){
          if (u >= 1.0){ clearInterval(theInterval) }
          var r = parseInt(lerp(start.r, end.r, u));
          var g = parseInt(lerp(start.g, end.g, u));
          var b = parseInt(lerp(start.b, end.b, u));
          var colorname = 'rgb('+r+','+g+','+b+')';
          el.style.setProperty(property, colorname);
          u += step_u;
        }, interval);
      };
      
      // in action
      let el = document.getElementById('box'); // your element
      let property = 'background-color';       // fading property
      
      let startColor = {r:255, g:  243, b:  205};
      let endColor   = {r:  248, g:108, b:107};  // dark turquoise
      fade(el,'background-color',startColor,endColor,1000);
      
      // fade back after 2 secs
      setTimeout(function(){
        fade(el,'background-color',endColor,startColor,1000);
      },2000);
    },
    getMe: function() {
      service.getMe().then(
        response => {

          if (this.me && this.me.subscription && this.me.subscription.credits && response.subscription.credits != this.me.subscription.credits) {
            this.animateBar();
          }

          this.me = response;

          if (!this.me.userIdentifier && localStorage.userIdentifier) {
            service.submitUserIdentifier(localStorage.userIdentifier);
          }

          if (this.me && this.me.subscription && (this.me.subscription.status == 3 || this.me.subscription.status == 1) && !this.me.subscription.isExpired) {
            fbq('trackCustom', 'PremiumAccess');
          } else if (this.me && this.me.subscription && (this.me.subscription.status == 3 || this.me.subscription.status == 1) && this.me.subscription.isExpired) {
            fbq('trackCustom', 'ExpiredPremiumAccess');
          }
        },
        () => {
          this.showError = true;
        }
      );
    }
  }
};
</script>
<!--
<script type="text/javascript">
  /*zE(function() {
    zE.setUser({email: "diegovianamelo@gmail.com"});
  });*/
</script> -->

<style lang="css">
.teste {
  margin: 12px !important;
}

.teste >>> .nav-link {
  border-radius: 5px !important;
}
</style>

